import { TableCell, TableRow } from '@material-ui/core'
import React from 'react'

export const ColumnaAltoCosto = () => {
    return (
        <TableRow>
            <TableCell></TableCell>
            <TableCell align="left">Nro Pedido Scienza</TableCell>
            <TableCell align="left">Presentación</TableCell>
            <TableCell align="left">Cantidad</TableCell>
            <TableCell align="left">Medicamente</TableCell>
            <TableCell align="left">Surge</TableCell>
            <TableCell align="left">Importe Alfabeta</TableCell>
            <TableCell align="left">Importe Aud</TableCell>
            <TableCell align="left">Apellido y Nombre</TableCell>
            <TableCell align="left">Fecha Pedido</TableCell>
            <TableCell align="left">Codigo Diagnostico</TableCell>
            <TableCell align="left">Diagnostico</TableCell>
            <TableCell align="left"></TableCell>
        </TableRow>
    )
}
